enum TabValue {
  overview = 'overview',
  employees = 'employees',
  phases = 'phases',
}

export default TabValue;
